import { isBefore } from 'date-fns';
import { useMemo } from 'react';
import { newTrialAllowedDate } from 'shared/constants';
import { useUser } from 'shared/hooks/use-user';
import { SubscriptionType } from 'shared/types/user-subscription';

export const useUserHadTrial = () => {
  const user = useUser();

  return useMemo(
    () =>
      !!user?.subscriptions?.find(
        ({ type, expiresAt, productId }) =>
          (type === SubscriptionType.Trial || productId?.includes('custom')) &&
          expiresAt &&
          isBefore(newTrialAllowedDate, expiresAt),
      ) || !!user?.user_metadata?.lifetime_trial_expires_date,
    [user?.subscriptions, user?.user_metadata?.lifetime_trial_expires_date],
  );
};
